<app-risk-filters
  (onFilter)="onFilter($event)"
  [defaultFilters]="defaultFilters"
>
</app-risk-filters>
<mat-card class="u-center-text" *ngIf="!(risks | async).length">
  <h4>{{'risks.Nessun rischio trovato' | translate}}</h4>
  <button *ngIf="canAdd" mat-raised-button (click)="addRisk()">{{'shared.Aggiungi' | translate}}</button>
</mat-card>
<div class="table-container" [hidden]="!(risks | async).length">
  <table
    mat-table
    matSort
    [dataSource]="risks"
    mat-table
    matSortDisableClear
    matSort
    matSortDirection="asc"
  >
    <ng-container matColumnDef="identifier">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'risks.Ident.' | translate}}</th>
      <td mat-cell *matCellDef="let row">
        {{ row.identifier }}
      </td>
    </ng-container>

    <ng-container matColumnDef="area">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'risks.Area' | translate}}</th>
      <td mat-cell *matCellDef="let row">
        {{ row.riskArea?.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="target">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'risks.Obiettivo' | translate}}</th>
      <td mat-cell *matCellDef="let row">
        {{ row.target?.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="category">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{'risks.Categoria contromisura' | translate}}
      </th>
      <td mat-cell *matCellDef="let row">
        {{ row.riskCategory?.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="owner">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header="risk_owner_description"
      >
        {{'risks.Risk owner' | translate}}
      </th>
      <td mat-cell *matCellDef="let row">
        {{ row.riskOwnerDescription }}
      </td>
    </ng-container>
    <ng-container matColumnDef="warning">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{'risks.Early warning indicator' | translate}}
      </th>
      <td mat-cell *matCellDef="let row">
        {{ row.warning }}
      </td>
    </ng-container>
    <ng-container matColumnDef="threat">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{'risks.Minaccia/Opportunità' | translate}}
      </th>
      <td mat-cell *matCellDef="let row">
        {{ row.threat }}
      </td>
    </ng-container>
    <ng-container matColumnDef="countermeasure">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'risks.Contromisura' | translate}}</th>
      <td mat-cell *matCellDef="let row">
        {{ row.countermeasure }}
      </td>
    </ng-container>
    <ng-container matColumnDef="riskActionee">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="risk_actionnee">
        {{'risks.Risk actionee' | translate}}
      </th>
      <td mat-cell *matCellDef="let row">
        {{ row.riskActionee }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <button
          *ngIf="canAdd"
          mat-icon-button
          mat-raised-button
          color="accent"
          (click)="$event.stopPropagation(); addRisk()"
        >
          <mat-icon matTooltip="{{'shared.Aggiungi' | translate}}">playlist_add</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="canEdit">
          <button
            mat-icon-button
            (click)="$event.stopPropagation(); editRisk(row)"
          >
            <mat-icon matTooltip="{{'shared.Modifica' | translate}}">create</mat-icon>
          </button>
        </ng-container>
        <button
          *ngIf="canSelect"
          mat-raised-button
          color="primary"
          (click)="selectRisk(row)"
        >
          {{'shared.Seleziona' | translate}}
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSizeOptions[0]"
    [length]="total | async"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
